import enLocaleData from 'react-intl/locale-data/en';
import koLocaleData from 'react-intl/locale-data/ko';

const localeData = [
    ...enLocaleData,
    ...koLocaleData
];

export default localeData;
